









import {
    computed,
    defineComponent,
} from '@vue/composition-api';
import SdsPageHeader from '@shared/components/pageHeader/SdsPageHeader.vue';
import {
    useI18n,
    useVuexStore,
} from '@superbet-group/web.lib.vue-utilities';
import { capitalize } from '@superbet-group/web.lib.utilities';
import { NavigationDataStore } from '@store/modules/navigation';

export default defineComponent({
    name: 'HomePageHeader',
    setup() {
        const { translate } = useI18n();

        const navigationModule = useVuexStore<NavigationDataStore>('navigation');

        const homeTitle = computed(() => {
            return navigationModule.getter('routeSeoData').value?.title ?? capitalize(translate('home'));
        });

        return {
            homeTitle,
        };
    },
    components: { SdsPageHeader },
});
